import styled, { css, keyframes } from 'styled-components';
import { buttoBaseStyle } from '@screens/lp-default/styles';

export const slideRightLeftFade = keyframes`
    0% {
    opacity: 1;
    transform: translateX(0);
  }
  100% {
    opacity: 0;
    transform: translateX(-50px);
  }
`;

export const slideBottomTopFade = keyframes`
    0% {
    opacity: 0;
    transform: translateY(50px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const slideBottomTopRightLeft = keyframes`
    0% {
    opacity: 0;
    transform: translateY(250px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const ToolCard = styled.div<{ isExpanded?: boolean }>`
  background: ${({ theme }) => theme.elsie.colors.interactive.subtle.default};
  border-radius: ${({ theme }) => theme.elsie.borderRadius.lg};
  cursor: pointer;
  display: flex;
  flex: ${({ isExpanded }) => (isExpanded === true ? 1 : '0 0 20%')};
  flex-direction: column;
  height: 168px;
  overflow: hidden;
  padding: 20px 12px;
  position: relative;
  transition: flex 0.7s ease-in-out;
`;

export const ToolCardTitle = styled.p<{ isExpanded?: boolean }>`
  animation: ${slideBottomTopFade} 1s ease 0s 1 normal forwards;
  color: ${({ theme }) => theme.elsie.colors.interactive.accent.hovered};
  display: ${({ isExpanded }) => (isExpanded ? 'block' : 'none')};
  font-size: ${({ theme }) => theme.elsie.fontSize.xs};
  font-weight: ${({ theme }) => theme.elsie.fontWeight.bold};
  letter-spacing: ${({ theme }) => theme.elsie.letterSpacing.sm};
  line-height: ${({ theme }) => theme.elsie.lineHeight.lg};
  margin: 0 0 12px 0;
  max-width: 100%;
  @media only screen and (max-width: 1340px) {
    max-width: 60%;
  }
`;

export const ToolCardTitleBottom = styled.p<{ isExpanded?: boolean }>`
  animation: ${slideBottomTopFade} 1s ease 0s 1 normal forwards;
  color: ${({ theme }) => theme.elsie.colors.interactive.accent.hovered};
  display: ${({ isExpanded }) => (isExpanded ? 'none' : 'block')};
  font-size: ${({ theme }) => theme.elsie.fontSize.xs};
  font-weight: ${({ theme }) => theme.elsie.fontWeight.bold};
  letter-spacing: ${({ theme }) => theme.elsie.letterSpacing.sm};
  line-height: ${({ theme }) => theme.elsie.lineHeight.lg};
  position: absolute;
  bottom: 10px;
`;

export const ToolCardDescription = styled.p<{ isExpanded?: boolean }>`
  animation: ${slideBottomTopFade} 1s ease 0s 1 normal forwards;
  color: ${({ theme }) => theme.elsie.colors.interactive.accent.hovered};
  display: ${({ isExpanded }) => (isExpanded ? 'block' : 'none')};
  font-size: ${({ theme }) => theme.elsie.fontSize.xs};
  font-weight: ${({ theme }) => theme.elsie.fontWeight.regular};
  letter-spacing: ${({ theme }) => theme.elsie.letterSpacing.sm};
  line-height: ${({ theme }) => theme.elsie.lineHeight.lg};
  margin: 0;
  max-width: calc(100% - 210px);
`;

export const ToolCardBackground = styled.picture<{ isExpanded?: boolean }>`
  animation: ${slideBottomTopFade} 1s ease 0s 1 normal forwards;
  position: absolute;
  bottom: 0;
  display: ${({ isExpanded }) => (isExpanded ? 'block' : 'none')};
  height: 100%;
  margin-bottom: -20px;
  margin-right: -210px;
  right: 0;
  z-index: 1;
  & img {
    min-height: 100%;
    object-fit: cover;
    width: 100%;
  }
`;

export const ToolCardButton = styled.span<{ isExpanded?: boolean; isClicked?: string }>`
  ${buttoBaseStyle};
  animation: ${({ isClicked }) =>
    isClicked !== null
      ? css`
          ${slideRightLeftFade} 0.4s ease-out forwards
        `
      : 'none'};
  display: ${({ isExpanded }) => (!isExpanded ? 'flex' : 'none')};
  flex-direction: row;
  align-items: center;
  border: none;
  border-radius: ${({ theme }) => theme.elsie.borderRadius.md};
  background-color: ${({ theme }) => theme.elsie.colors.inverse.interactive.accent.default};
  padding: ${({ theme }) => theme.elsie.dimension[6]};
  &:hover {
    background-color: ${({ theme }) => theme.elsie.colors.inverse.interactive.accent.hovered};
  }
  &:active {
    background-color: ${({ theme }) => theme.elsie.colors.inverse.interactive.accent.pressed};
  }
  position: absolute;
  right: 10px;
  top: 10px;
`;
